import React from 'react'

const SwatchIcon = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='-23 -10 67 67' fill={fill} width={width} height={height} {...props}>
    <text fontSize='8.5' fontWeight='bold'>
      <tspan x='-10.5' y='36'>
        View fabric
      </tspan>
      <tspan x='0.5' y='50'>
        detail
      </tspan>
    </text>
    <path d='M8.75 4.06v9.182L13.843 4H8.809a.745.745 0 0 1-.059.06zm-1.5 11.308V4.975L3.001 7.524l4.249 7.844zm0-12.143A.75.75 0 0 1 8 2.5h6.69a.75.75 0 0 1 .932-.151l7 4a.75.75 0 0 1 .285 1.013l-6.759 12.265c-1.301 2.237-4.182 3.037-6.523 1.773a4.692 4.692 0 0 1-1.67-1.634.751.751 0 0 1-.114-.159l-6.5-12a.75.75 0 0 1 .273-1L7.25 3.225zm1.5 13.886v.139c0 .017 0 .033-.002.05.022 1.131.603 2.21 1.608 2.79 1.612.87 3.603.318 4.487-1.202l6.394-11.603-5.698-3.256L9.16 15.606c-.259.48-.392.995-.41 1.505zM12 18a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z' />
  </svg>
)

export default SwatchIcon
